import { PagedSearch } from 'src/app/shared/model/';
export class CommitteeSearchDto extends PagedSearch {
  NameKeyword: string;
  TypeKeyword: string;
  AffCode: string;
  Active: boolean;
  CommitteeIds: number[];
  IncludeInactive: boolean;
}
